/**
 * Language analytics — consent-aware by construction.
 *
 * We only push to `window.dataLayer`. GTM is the single browser owner of GA4
 * and Consent Mode v2 gates delivery, exactly like the ecommerce layer, so
 * nothing here can bypass consent. No contact details, health answers or
 * form content are ever included.
 */

import type { Lang } from "./config";

function push(payload: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(payload);
}

/**
 * Keeps `content_language` available to every subsequent page_view and
 * conversion event. Reflects what is ACTUALLY displayed (English fallback
 * included), because it is derived from the active language state.
 */
export function pushContentLanguage(lang: Lang): void {
  push({ content_language: lang });
}

/** One event per deliberate switch. */
export function trackLanguageToggle(from: Lang, to: Lang): void {
  if (from === to) return;
  push({
    event: "language_toggle",
    from_language: from,
    to_language: to,
    page_path:
      typeof window === "undefined" ? "" : window.location.pathname + window.location.search,
  });
}
